/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Tooltip } from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import { AppContext } from '@keystone/common';
import { withAllContexts } from '../../common/HOCs';
import APIClient from '../../common/APIClient';

class ViewRules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rules: [],
      loading: false,
    };
  }

  async componentDidMount() {
    const { setNotification, registerReloadFunction } = this.context;
    registerReloadFunction(this.getTableData);
    setNotification(null);
    this.setState({ loading: true });
    await this.getTableData();
    this.setState({ loading: false });
  }

  componentWillUnmount() {
    const { unregisterReloadFunction, setNotification } = this.context;
    unregisterReloadFunction();
    setNotification(null, null);
  }

  getTableData = async () => {
    const { user, handleError } = this.context;
    try {
      const rules = await APIClient.fetchRules(user);
      this.setState({ rules: rules.response });
    } catch (err) {
      handleError(err);
    }
  };

  rendererMatchingString = (cellData) => {
    return (
      <Tooltip
        content={cellData.value}
        element={<p>{cellData.value}</p>}
        position="left center"
        event="hover"
        hoverable
      />
    );
  };

  rendererDisplayMessage = (cellData) => {
    return (
      <Tooltip
        content={cellData.rowData.description}
        element={<p>{cellData.value}</p>}
        position="left center"
        event="hover"
        hoverable
      />
    );
  };

  render() {
    const { vadContext } = this.props;
    const { loading, rules } = this.state;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={12}>
            <h1>Rules</h1>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12}>
            <DataTable
              data={rules}
              loading={loading}
              search
              searchPlaceholder="Search"
              resizableColumns
              columnResizeMode="fit"
              reorderableColumns
              selection={vadContext.selectedRows}
              onSelectionChange={(e) => {
                vadContext.setSelectedRows(e);
              }}
              selectionMode="multiple"
              metaKeySelection={false}
              scrollable
              scrollHeight="315%"
            >
              <DataTable.Column
                field="matchingString"
                header="Search String"
                sortable
                initialWidth="40%"
                renderer={(cellData) => this.rendererMatchingString(cellData)}
              />
              <DataTable.Column
                field="displayMessage"
                header="Resolution Message"
                sortable
                initialWidth="55%"
                renderer={(cellData) => this.rendererDisplayMessage(cellData)}
              />
            </DataTable>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

ViewRules.contextType = AppContext;

ViewRules.propTypes = {
  vadContext: PropTypes.shape({
    selectedRows: PropTypes.arrayOf(PropTypes.object).isRequired,
    setSelectedRows: PropTypes.func.isRequired,
  }).isRequired,
};

export default withAllContexts(ViewRules);
